var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import StyledIcon from './StyledIcon';

var CircleCheckTranslateIcon = function CircleCheckTranslateIcon(props) {
  return React.createElement(
    StyledIcon,
    _extends({}, props, { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 48 48' }),
    React.createElement(
      'g',
      { transform: 'translate(-467.000000, -4701.000000)' },
      React.createElement(
        'g',
        { id: 'Group-Copy-34', transform: 'translate(401.000000, 4667.000000)' },
        React.createElement(
          'g',
          { id: 'checkball_48x48', transform: 'translate(66.000000, 34.000000)' },
          React.createElement('circle', { id: 'Oval', fill: '#2CA01C', cx: '24', cy: '24', r: '24' }),
          React.createElement('path', { d: 'M24.165525,32.3880939 L37.9771668,18.5994793 C38.5475591,18.0415585 38.5475591,17.0851228 37.9364245,16.527202 L36.1437631,14.813588 C35.5733708,14.2556672 34.6362977,14.2556672 34.0659054,14.8534395 L21.2728213,27.566064 L15.8133523,22.3056677 C15.24296,21.7477468 14.2651446,21.7875983 13.6947523,22.3455191 L11.9428332,24.0989846 C11.3724409,24.6569054 11.3724409,25.6133411 11.9835755,26.1712619 L20.2950059,34.1415594 C20.9061405,34.6994802 21.8432136,34.6994802 22.4136059,34.1415594 L24.165525,32.3880939 Z', id: 'Path', fill: '#FFFFFF' })
        )
      )
    )
  );
};
export default CircleCheckTranslateIcon;